/* Mostashop — page « Offres Amazon » : apparition en fondu au défilement.
   Repli sans JS (ou sans IntersectionObserver, ou animations réduites) :
   la classe reveal-ready n'est jamais ajoutée, les cartes restent visibles. */
(function () {
  'use strict';

  var DESIGN_MODE = document.documentElement.getAttribute('data-design-mode') === 'true';
  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    if (DESIGN_MODE || REDUCED_MOTION || !('IntersectionObserver' in window)) return;
    var grids = document.querySelectorAll('[data-amz-offers-grid]');
    if (!grids.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    grids.forEach(function (grid) {
      grid.classList.add('reveal-ready');
      grid.querySelectorAll('.amazon-offer-card').forEach(function (card) {
        observer.observe(card);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initReveal);
  else initReveal();
})();
